export default __webpack_public_path__ + "static/media/Group1432.78c8d2a9.svg";